import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function File2Icon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="File2Icon" className={clsx(undefined, "Icon", className)} fill="none">
            <g id="Grupo_455" transform="translate(-3 -1)">
                <path
                    id="Trazado_6111"
                    d="M21.6,2H7.2A3.2,3.2,0,0,0,4,5.2V30.8A3.2,3.2,0,0,0,7.2,34H26.4a3.2,3.2,0,0,0,3.2-3.2V10Z"
                    transform="translate(0)"
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="Trazado_6112"
                    d="M14,2v8.146a4.073,4.073,0,0,0,4.073,4.073h8.146"
                    transform="translate(3.382)"
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="Trazado_6113"
                    d="M12.073,9H8"
                    transform="translate(2.151 4.2)"
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="Trazado_6114"
                    d="M24.291,13H8"
                    transform="translate(0.654 6.6)"
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
                <path
                    id="Trazado_6115"
                    d="M24.291,17H8"
                    transform="translate(0.654 9)"
                    fill="none"
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                />
            </g>
        </SvgIcon>
    );
}
